export default "__VITE_ASSET__KmnTGMd3__"